export const TIMEZONES = [
  {
    value: "minus12",
    short: "Etc/GMT+12",
    label: "GMT -12:00 (International Date Line West)",
  },
  {
    value: "minus11",
    short: "Etc/GMT+11",
    label: "GMT -11:00 (Midway Island, Samoa)",
  },
  { value: "minus10", short: "Etc/GMT+10", label: "GMT -10:00 (Hawaii)" },
  { value: "minus9", short: "Etc/GMT+9", label: "GMT -09:00 (Alaska)" },
  {
    value: "minus8",
    short: "Canada/Pacific",
    label: "GMT -08:00 (Pacific Time, US & Canada)",
  },
  {
    value: "minus7",
    short: "Canada/Mountain",
    label: "GMT -07:00 (Mountain Time, US & Canada)",
  },
  {
    value: "minus6",
    short: "Canada/Central",
    label: "GMT -06:00 (Central Time, US & Canada)",
  },
  {
    value: "minus5",
    short: "Canada/Eastern",
    label: "GMT -05:00 (Eastern Time, US & Canada)",
  },
  {
    value: "minus4",
    short: "Canada/Atlantic",
    label: "GMT -04:00 (Atlantic Time, Canada)",
  },
  {
    value: "minus3",
    short: "America/Argentina/Buenos_Aires",
    label: "GMT -03:00 (Buenos Aires, Georgetown)",
  },
  {
    value: "minus2",
    short: "America/Noronha",
    label: "GMT -02:00 (Mid-Atlantic)",
  },
  {
    value: "minus1",
    short: "Atlantic/Azores",
    label: "GMT -01:00 (Azores, Cape Verde Islands)",
  },
  {
    value: "zero",
    short: "Europe/London",
    label: "GMT +00:00 (London, Lisbon, Casablanca)",
  },
  {
    value: "plus1",
    short: "Europe/Berlin",
    label: "GMT +01:00 (Berlin, Rome, Paris, Budapest)",
  },
  {
    value: "plus2",
    short: "Europe/Athens",
    label: "GMT +02:00 (Athens, Cairo, Jerusalem)",
  },
  {
    value: "plus3",
    short: "Europe/Moscow",
    label: "GMT +03:00 (Moscow, Baghdad, Riyadh)",
  },
  {
    value: "plus4",
    short: "Asia/Dubai",
    label: "GMT +04:00 (Dubai, Baku, Tbilisi)",
  },
  {
    value: "plus5",
    short: "Asia/Tashkent",
    label: "GMT +05:00 (Islamabad, Karachi, Tashkent)",
  },
  {
    value: "plus6",
    short: "Asia/Dhaka",
    label: "GMT +06:00 (Dhaka, Almaty, Novosibirsk)",
  },
  {
    value: "plus7",
    short: "Asia/Bangkok",
    label: "GMT +07:00 (Bangkok, Hanoi, Jakarta)",
  },
  {
    value: "plus8",
    short: "Asia/Shanghai",
    label: "GMT +08:00 (Beijing, Singapore, Perth)",
  },
  {
    value: "plus9",
    short: "Asia/Tokyo",
    label: "GMT +09:00 (Tokyo, Seoul, Osaka)",
  },
  {
    value: "plus10",
    short: "Australia/Sydney",
    label: "GMT +10:00 (Sydney, Melbourne, Brisbane)",
  },
  {
    value: "plus11",
    short: "Asia/Magadan",
    label: "GMT +11:00 (Magadan, Solomon Islands)",
  },
  {
    value: "plus12",
    short: "Pacific/Auckland",
    label: "GMT +12:00 (Auckland, Fiji, Kamchatka)",
  },
];
